import { render, staticRenderFns } from "./TheGrottaHomeBook.vue?vue&type=template&id=aa3ba194&scoped=true"
import script from "./TheGrottaHomeBook.vue?vue&type=script&lang=js"
export * from "./TheGrottaHomeBook.vue?vue&type=script&lang=js"
import style0 from "./TheGrottaHomeBook.vue?vue&type=style&index=0&id=aa3ba194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3ba194",
  null
  
)

export default component.exports